Number.isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' &&
    isFinite(value) &&
    Math.floor(value) === value;
};

let GlobalHelper = function () {
    /**
    * Cambia la hora en Date() para que BD lo guarde correctamente y no con +3 hs.
    * @param {any} date
    */
    function _dateBD() {
        let hora =  Date.now() - 10800000 ;
        let horaParaBD = new Date(hora);
        return horaParaBD
    }
    
    /**
     * Convierte un numero de documento
     * @param {any} numeroDocumentoAconvertir
     * @param {any} tipoDocumento
     */
    function _convertirNumeroDocumento(numeroDocumentoAconvertir, tipoDocumento) {
        let resultado;
        switch (tipoDocumento) {
            case "CUIT":
                resultado = convertirCuilCuitCie(numeroDocumentoAconvertir);
                break;
            case "CUIL":
                resultado = convertirCuilCuitCie(numeroDocumentoAconvertir);
                break;
            case "CIE":
                resultado = convertirCuilCuitCie(numeroDocumentoAconvertir);
                break;
            case "DNI":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "LE":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "LC":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "CI":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "PTE":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "CD":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
        }
        return resultado;
    }


    /**
     * Convierte un numero de documento al formato correspondiente (CUIL-CUIT-CIE)
     * @param {any} numeroCuilCuitCie
     */
    function convertirCuilCuitCie(numeroCuilCuitCie) {
        let num = (numeroCuilCuitCie) ? numeroCuilCuitCie.toString() : "";
        return num.substring(2, 0) + '-' + num.substring(num.length - 1, 2) + '-' + num.substring(num.length - 1);
    }

    /**
     * Convierte un numero de documento al formato correspondiente (DNI-LE-LC-CI-PTE-CD)
     * @param {any} numeroDniLeLcCiPteCd
     */
    function convertirDniLeLcCiPteCd(numeroDniLeLcCiPteCd) {
        let num = (numeroDniLeLcCiPteCd) ? numeroDniLeLcCiPteCd.toString().replace(/\./g, '') : "";
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');
        }
        return num;
    }

    /**
     * Convierte un numero con el formato miles y millones con decimales incorporados en parametro
     * @param {any} numeroConDecimales
     */
    function _convertirNumeroConDecimales(numeroConDecimales) {
        let limites = (numeroConDecimales) ? numeroConDecimales.toString() : "";
        let enterosLimite = limites.substring(0, limites.length - 2);
        let decimalesLimite = limites.substring(limites.length - 2, limites.length);

        let numeroAconvertir = enterosLimite.toString();
        let num = numeroAconvertir.replace(/\./g, '');
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');

            if (num.substring(0, 2) === "-.") {
                num = num.substring(0, 1) + num.substring(2, num.length);
            }
        }

        return num + ',' + decimalesLimite;
    }

    /**
     * Depende de la seleccion puede convierte un numero con el formato miles y millones con decimales no incorporados en parametro ó
       convertir un numero con el formato miles y millones
     * @param {any} seleccion
     * @param {any} numeroSinDecimales
     */
    function _convertirNumeroSinDecimales(seleccion, numeroSinDecimales) {
        let patron = new RegExp(/\./g);

        if (!patron.test(numeroSinDecimales)) {
            let num = (numeroSinDecimales) ? numeroSinDecimales.toString().replace(/\./g, '') : "";
            if (numeroSinDecimales == 0) {
                num = numeroSinDecimales;
            }
            else {
                if (!isNaN(num)) {
                    num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
                    num = num.split('').reverse().join('').replace(/^[\.]/, '');

                    if (num.substring(0, 2) === "-.") {
                        num = num.substring(0, 1) + num.substring(2, num.length);
                    }
                }
            }

            return seleccion == 0 ? num + ",00" : num
        }
        return numeroSinDecimales;
    }

    /**
    * Elimina decimales
    * @param {any} numeroAeliminarDecimales
    */
    function _eliminarDecimales(numeroAeliminarDecimales) {
        let num = (numeroAeliminarDecimales) ? numeroAeliminarDecimales.toString() : "";
        return num.substring(0, num.toString().length - 2);
    }

    /**
    * Formatea fechas
    * @param {any} date
    */
    function _formatDate(date) {
        var dateParts = date.split("-");

        var newDate = new Date();
        var dd = dateParts[2].substr(0, 2);
        var mm = dateParts[1];
        var yyyy = dateParts[0];

        newDate = dd + '/' + mm + '/' + yyyy;

        return newDate;
    }

    function _obtenerLimitesEmpresaCliente(empresas, novedades, cliente) {
        const { LimiteAsignado, LimitePorCuit, LimiteSinAsignar } = cliente;

        let limiteAsignadoAux = 0;

        empresas.filter(e0 => e0.SolicitudEstado != 11 && e0.SolicitudEstado != 4).forEach((e, ei) => {
            if (e.esNueva == true) {
                limiteAsignadoAux += parseFloat(e.LimiteCompra);
            } else {
                let novedad = novedades.find(n => n.NovedadCampoCodigo == "LIMCO_EMPR" && (n.EmpresaVisaId == e.Id || n.EmpresaId == e.Id));

                if (novedad) {
                    limiteAsignadoAux += parseFloat(novedad.ValorNovedad);
                } else {
                    limiteAsignadoAux += parseFloat(e.LimiteCompra);
                }
            }
        });

        return {
            LimitePorCuit,
            LimiteAsignado: limiteAsignadoAux,
            LimiteSinAsignar: (LimitePorCuit - limiteAsignadoAux)
        }
    }

    /**
    * Compara una fecha mayor o igual al del dia de hoy
    * @param {any} date (Formato: DD/MM/YYYY)
    */
    function _compararFechaDeHoy(date) {
        let dateParts = date.split("/");
        let newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        let dateNow = new Date().toISOString().slice(0, 19).replace('T', ' ').slice(0, 10).split("-");
        let paramDate = new Date(dateNow[0], dateNow[1] - 1, dateNow[2]);
        let actualDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        let fecha = newDate.toISOString().slice(0, 19).replace('T', ' ');
        let estado = false;
        if (paramDate <= actualDate) {
            estado = true;
        }

        return {
            estado: estado,
            fecha: fecha
        }
    }

    /**
    * Completa con 2 decimales
    * @param {any} numero
    */
    function _completarDecimales(numero) {
        let nroFinal;
        let limites = (numero) ? numero.toString() : "";

        if (limites.indexOf('.') > 0) {
            let nroSplit = limites.split('.');

            switch (nroSplit[1].length) {
                case 0:
                    nroFinal = limites + '.00';
                    break;
                case 1:
                    nroFinal = nroSplit[0] + '.' + nroSplit[1] + '0';
                    break;
                case 2:
                    nroFinal = limites;
                default:
            }
        }
        else {
            nroFinal = limites + '.00';
        }

        return nroFinal;
    }

    function _asignarNovedadesEmpresa(novedades){
        let novedadesEmpresa={};

        novedades.map(novedad=>{
            switch (novedad.NovedadCampoCodigo){
                case 'LIMCO_EMPR':{
                    novedadesEmpresa.LimiteCompra = !novedad.delete ? novedad : null;
                    break;
                }
                case 'VIG_A_EMPR':{
                    novedadesEmpresa.VigenciaAlta = !novedad.delete ? novedad : null;
                    break;
                }
                case 'VIG_R_EMPR':{
                    novedadesEmpresa.VigenciaRenovacion = !novedad.delete ? novedad : null;
                    break;
                }
                case 'PERAD_EMPR':{
                    novedadesEmpresa.PermiteAdelantos = !novedad.delete ? novedad : null;
                    break;
                }
                case 'PERCU_EMPR':{
                    novedadesEmpresa.PermiteCuotas = !novedad.delete ? novedad : null;
                    break;
                }
                case 'BONRE_EMPR':{
                    novedadesEmpresa.PorcentajeBonificacionRenovacion = !novedad.delete ? novedad : null;
                    break;
                }
                case 'LIMTR_EMPR':{
                    novedadesEmpresa.TieneLimiteTransaccion = !novedad.delete ? novedad : null;
                    break;
                }
                case 'NUECL_EMPR':{
                    novedadesEmpresa.GeneraNuevaClave = !novedad.delete ? novedad : null;
                    break;
                }
                case 'DESTI_EMPR':{
                    novedadesEmpresa.DestinatarioReportes = !novedad.delete ? novedad : null;
                    break;
                }
                case 'CARTE_EMPR':{
                    novedadesEmpresa.CarteraId = !novedad.delete ? novedad : null;
                    break;
                }
                case 'CONEX_EMPR':{
                    novedadesEmpresa.PermiteConsumosExterior = !novedad.delete ? novedad : null;
                    break;
                }
                case 'REPCU_EMPR':{
                    novedadesEmpresa.GeneraReporteCuentaCentral = !novedad.delete ? novedad : null;
                    break;
                }
                case 'ACTRE_EMPR':{
                    novedadesEmpresa.CobraValorRenovacion = !novedad.delete ? novedad : null;
                    break;
                }
                case 'MODLI_EMPR':{
                    novedadesEmpresa.TomaGastosModeloLiquidacion = !novedad.delete ? novedad : null;
                    break;
                }
                case 'DOMIC_EMPR':{
                    novedadesEmpresa.domicilio = !novedad.delete ? novedad : null;
                    break;
                }
                case 'DENOM_EMPR':{
                    novedadesEmpresa.Descripcion = !novedad.delete ? novedad : null;
                    break;
                }
                case 'ESCON_EMPR':{
                    novedadesEmpresa.EsConfidencial = !novedad.delete ? novedad : null;
                    break;
                }
                case 'DOMICILIO':{
                    novedadesEmpresa.domicilio = !novedad.delete ? novedad : null;
                    break;
                }
                case 'RUBRO_EMPR':{
                    novedadesEmpresa.RubroIncluidoExcluido = !novedad.delete ? novedad : null;
                    break;
                }
                case 'RUBEX_EMPR':{
                    novedadesEmpresa.RubrosExcepto = !novedad.delete ? novedad : null;
                    break;
                }
                case 'RUBIN_EMPR':{
                    novedadesEmpresa.RubrosIncluido = !novedad.delete ? novedad : null;
                    break;
                }  
                case 'CANTMAXDIAS_EMPR':{
                    novedadesEmpresa.CantidadMaximaDias = !novedad.delete ? novedad : null;
                    break;
                }
                case 'GRUPA_EMPR':{
                    novedadesEmpresa.Afinidad = !novedad.delete ? novedad : null;
                    break;
                }
                case 'IMPORTEGASTOS_EMPR':{
                    novedadesEmpresa.ImporteGastos = !novedad.delete ? novedad : null;
                    break;
                }
                case 'FETOP_EMPR':{
                    novedadesEmpresa.FechaTopeAgro = !novedad.delete ? novedad : null;
                    break;
                }
            }
        })
        return novedadesEmpresa;
    }

    function _asignarCodigoNovedadEmpresa(campo){
        let codigo='';

            switch (campo){
                case 'RubrosExcepto' :{
                    codigo = 'RUBEX_EMPR';
                    break;
                }
                case 'RubrosIncluido' :{
                    codigo = 'RUBIN_EMPR';
                    break;
                }
                case 'LimiteCompra' :{
                    codigo = 'LIMCO_EMPR';
                    break;
                }
                case 'RubroIncluidoExcluido' :{
                    codigo = 'RUBRO_EMPR';
                    break;
                }
                case 'VigenciaAlta' :{
                    codigo = 'VIG_A_EMPR';
                    break;
                }
                case 'VigenciaRenovacion' :{
                    codigo = 'VIG_R_EMPR';
                    break;
                }
                case 'PermiteAdelantos' :{
                    codigo = 'PERAD_EMPR';
                    break;
                }
                case 'PermiteCuotas' :{
                    codigo = 'PERCU_EMPR';
                    break;
                }
                case 'PorcentajeBonificacionRenovacion' :{
                    codigo = 'BONRE_EMPR';
                    break;
                }
                case 'TieneLimiteTransaccion' :{
                    codigo = 'LIMTR_EMPR';
                    break;
                }
                case 'GeneraNuevaClave' :{
                    codigo = 'NUECL_EMPR';
                    break;
                }
                case 'DestinatarioReportes' :{
                    codigo = 'DESTI_EMPR';
                    break;
                }
                case 'CarteraId' :{
                    codigo = 'CARTE_EMPR';
                    break;
                }
                case 'PermiteConsumosExterior' :{
                    codigo = 'CONEX_EMPR';
                    break;
                }
                case 'GeneraReporteCuentaCentral' :{
                    codigo = 'REPCU_EMPR';
                    break;
                }
                case 'CobraValorRenovacion' :{
                    codigo = 'ACTRE_EMPR';
                    break;
                }
                case 'TomaGastosModeloLiquidacion' :{
                    codigo = 'MODLI_EMPR';
                    break;
                }
                case 'domicilio' :{
                    codigo = 'DOMICILIO';
                    break;
                }
                case 'Descripcion' :{
                    codigo = 'DENOM_EMPR';
                    break;
                }
                case 'EsConfidencial' :{
                    codigo = 'ESCON_EMPR';
                    break;
                }
                case 'DomicilioCalle' :{
                    codigo = 'DMCAL_EMPR';
                    break;
                }
                case 'DomicilioNumero' :{
                    codigo = 'DMNRO_EMPR';
                    break;
                }
                case 'DomicilioLod' :{
                    codigo = 'DMLOD_EMPR';
                    break;
                }
                case 'DomicilioCodigoPostal' :{
                    codigo = 'DMCOP_EMPR';
                    break;
                }
                case 'DomicilioCodigoGeografico' :{
                    codigo = 'DMCGE_EMPR';
                    break;
                }
                case 'DomicilioDepartamentoPartido' :{
                    codigo = 'DMDPT_EMPR';
                    break;
                }
                case 'CantidadMaximaDias' :{
                    codigo = 'CANTMAXDIAS_EMPR';
                    break;
                }
                case 'ImporteGastos' :{
                    codigo = 'IMPORTEGASTOS_EMPR';
                    break;
                }
                case 'Afinidad' :{
                    codigo = 'GRUPA_EMPR';
                    break;
                }
                case 'FechaTopeAgro' :{
                    codigo = 'FETOP_EMPR';
                    break;
                }
            }
         
        return codigo;
    }

    return {
        AsignarNovedadesEmpresa: function (novedades) {
            return _asignarNovedadesEmpresa(novedades);
        },
        AsignarCodigoNovedadEmpresa: function (campo) {
            return _asignarCodigoNovedadEmpresa(campo);
        },
        ConvertirNumeroDocumento: function (numeroDocumentoAconvertir, tipoDocumento) {
            return _convertirNumeroDocumento(numeroDocumentoAconvertir, tipoDocumento);
        },
        DateBD: function(){
            return _dateBD();
        },

        ConvertirNumeroConDecimales: function (numeroConDecimales) {
            return _convertirNumeroConDecimales(numeroConDecimales);
        },

        ConvertirNumeroSinDecimales: function (numeroSinDecimales) {
            return _convertirNumeroSinDecimales(0, numeroSinDecimales);
        },

        ConvertirNumeroMilesMillones: function (numeroMilesMillones) {
            return _convertirNumeroSinDecimales(1, numeroMilesMillones);
        },

        EliminarDecimales: function (numeroAeliminarDecimales) {
            return _eliminarDecimales(numeroAeliminarDecimales);
        },

        FormatDate: function (date) {
            return _formatDate(date);
        },

        CompararFechaDeHoy: function (date) {
            return _compararFechaDeHoy(date);
        },

        ObtenerLimitesEmpresaCliente: function (empresas, novedades, cliente) {
            return _obtenerLimitesEmpresaCliente(empresas, novedades, cliente);
        },

        CompletarDecimales: function (numero) {
            return _completarDecimales(numero);
        },

        ParseFloat: function (num) {
            return parseFloat((num + "").replace(/^(.*\.\d\d)\d*$/, '$1'))
        },

        FormatearLimite: function (valor) {
            if (isNaN(valor)) {
                return "0,00";
            } else {
                if (Number.isInteger(valor)) {
                    return _convertirNumeroSinDecimales(0, valor);
                } else {
                    return _convertirNumeroConDecimales(valor);
                }
            }
        }
    }
}

let globalHelper = new GlobalHelper();

module.exports = globalHelper;


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Common/Helpers/GlobalHelper.js